import {
  AverageImpressionGreyIcon,
  AverageImpressionYellowIcon,
  BadImpressionGreyIcon,
  BadImpressionYellowIcon,
  GoodImpressionGreyIcon,
  GoodImpressionYellowIcon,
  PerfectImpressionGreyIcon,
  PerfectImpressionYellowIcon,
  TerribleImpressionGreyIcon,
  TerribleImpressionYellowIcon,
} from "../../../assets/images";
import { TableHeadersType } from "../../../constant/tableHeadersConstants/tableHeadersType";
import { SingleJobsScheduledHoursListType } from "../../../redux/scheduling/schedulingTypes";
import { CircularAvatar } from "../../commons";

type AppProps = {
  data: SingleJobsScheduledHoursListType[] | [];
  tableHeader: TableHeadersType[];
  setParticulerjobsUsersList: React.Dispatch<
    React.SetStateAction<SingleJobsScheduledHoursListType[] | []>
  >;
  setButtonDisable: React.Dispatch<React.SetStateAction<boolean>>;
};

const JobWorkingUsersTableData = ({
  data,
  tableHeader,
  setParticulerjobsUsersList,
  setButtonDisable,
}: AppProps) => {
  const handleUsersRatting = (rating: string, index: number) => {
    const temp: SingleJobsScheduledHoursListType[] | [] = JSON.parse(
      JSON.stringify(data)
    );
    temp[index]["rating"] = rating;
    temp[index]["comment"] = "";
    setParticulerjobsUsersList([...temp]);
  };
  const handleUsersComment = (comment: string, index: number) => {
    const temp: SingleJobsScheduledHoursListType[] | [] = JSON.parse(
      JSON.stringify(data)
    );
    temp[index]["comment"] = comment;
    setParticulerjobsUsersList([...temp]);
  };
  return (
    <>
      {data?.length > 0 &&
        data?.map((user: SingleJobsScheduledHoursListType, index: number) => {
          return (
            <>
              <tr style={{ backgroundColor: "white" }}>
                {tableHeader?.map((header: TableHeadersType) => {
                  if (header.value == "userName") {
                    return (
                      <td style={{ minWidth: "200px" }}>
                        <div className="d-flex">
                          <div className="mr-2">
                            <CircularAvatar
                              name={user?.user_name}
                              image={user?.profile_pic?.file_url}
                            />
                          </div>
                          <div>
                            <div>{user?.user_name}</div>
                            <div>{user?.job_title}</div>
                          </div>
                        </div>
                      </td>
                    );
                  } else if (header?.value === "hours") {
                    return <td>{user?.hours}</td>;
                  } else if (header?.value === "rateEmployeesWork") {
                    return (
                      <td>
                        <div className="d-flex g-2">
                          <div
                            className="pointer mr-3"
                            onClick={() => handleUsersRatting("1", index)}
                          >
                            <img
                              src={
                                user?.rating == "1"
                                  ? TerribleImpressionYellowIcon
                                  : TerribleImpressionGreyIcon
                              }
                              alt="Terrible"
                            />
                            <div
                              style={{
                                margin: "0px",
                                fontSize: "10px",
                                fontWeight:
                                  user?.rating == "1" ? "500" : "normal",
                                color:
                                  user?.rating == "1" ? "#262a44" : "#9a9fb8",
                              }}
                            >
                              Terrible
                            </div>
                          </div>
                          <div
                            className="pointer mr-3"
                            onClick={() => handleUsersRatting("2", index)}
                          >
                            <img
                              src={
                                user?.rating == "2"
                                  ? BadImpressionYellowIcon
                                  : BadImpressionGreyIcon
                              }
                              alt="bad"
                            />
                            <div
                              style={{
                                margin: "0px",
                                fontSize: "10px",
                                fontWeight:
                                  user?.rating == "2" ? "500" : "normal",
                                color:
                                  user?.rating == "2" ? "#262a44" : "#9a9fb8",
                              }}
                            >
                              Bad
                            </div>
                          </div>
                          <div
                            className="pointer mr-3"
                            onClick={() => handleUsersRatting("3", index)}
                          >
                            <img
                              src={
                                user?.rating == "3"
                                  ? AverageImpressionYellowIcon
                                  : AverageImpressionGreyIcon
                              }
                              alt="confused"
                            />
                            <div
                              style={{
                                margin: "0px",
                                fontSize: "10px",
                                fontWeight:
                                  user?.rating == "3" ? "500" : "normal",
                                color:
                                  user?.rating == "3" ? "#262a44" : "#9a9fb8",
                              }}
                            >
                              Okay
                            </div>
                          </div>
                          <div
                            className="pointer mr-3"
                            onClick={() => handleUsersRatting("4", index)}
                          >
                            <img
                              src={
                                user?.rating == "4"
                                  ? GoodImpressionYellowIcon
                                  : GoodImpressionGreyIcon
                              }
                              alt="good"
                            />
                            <div
                              style={{
                                margin: "0px",
                                fontSize: "10px",
                                fontWeight:
                                  user?.rating == "4" ? "500" : "normal",
                                color:
                                  user?.rating == "4" ? "#262a44" : "#9a9fb8",
                              }}
                            >
                              Good
                            </div>
                          </div>
                          <div
                            className="pointer mr-3"
                            onClick={() => handleUsersRatting("5", index)}
                          >
                            <img
                              src={
                                user?.rating == "5"
                                  ? PerfectImpressionYellowIcon
                                  : PerfectImpressionGreyIcon
                              }
                              alt="perfect"
                            />
                            <div
                              style={{
                                margin: "0px",
                                fontSize: "10px",
                                fontWeight:
                                  user?.rating == "5" ? "500" : "normal",
                                color:
                                  user?.rating == "5" ? "#262a44" : "#9a9fb8",
                              }}
                            >
                              Perfect
                            </div>
                          </div>
                        </div>
                      </td>
                    );
                  }
                })}
              </tr>
              {user?.rating && +user?.rating < 4 && (
                <tr style={{ backgroundColor: "white", width: "100%" }}>
                  <td
                    colSpan={3}
                    style={{
                      paddingLeft: "2%",
                      paddingRight: "2%",
                      borderTop: "none",
                    }}
                  >
                    <label htmlFor="lastName">
                      Comment<span className="text-danger">*</span>
                    </label>
                    <textarea
                      value={user?.comment}
                      onChange={(e) =>
                        handleUsersComment(e.target.value, index)
                      }
                      style={{ width: "100%", borderColor: "rgb 191 203 225" }}
                      rows={2}
                    />
                  </td>
                </tr>
              )}
            </>
          );
        })}
    </>
  );
};
export default JobWorkingUsersTableData;
